import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';

export default function PrivateRoutes() {
    const { user, isLoading } = useAuth();

    if (isLoading) return null; // Or a loading spinner

    return user ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />
}